export default {
  data: {
    __schema: {
      types: [
        {
          kind: 'INTERFACE',
          name: 'Transaction',
          possibleTypes: [
            { name: 'InitTransaction' },
            { name: 'CloseTransaction' },
            { name: 'PaymentTransaction' }
          ]
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/graphql/fragment.tsx